import gql from 'graphql-tag'
import di from 'di'

import addList from '@wittignl/js-core/apollo/mutations/addList'
import updateList from '@wittignl/js-core/apollo/mutations/updateList'
import deleteList from '@wittignl/js-core/apollo/mutations/deleteList'
import update from '@wittignl/js-core/apollo/mutations/update'

export default {

    create: function(action){

        return di.get('apollo').mutate({

            mutation: gql`
                mutation ($actionInput: CreateActionInput!) {
                    createAction(input: $actionInput){
                        id
                    }
                }`,

            variables: {
                actionInput: action
            }
        });
    },

    update: function(action){

        return di.get('apollo').mutate({

            mutation: gql`
                mutation ($actionInput: UpdateActionInput!) {
                    updateAction(input: $actionInput){
                        id
                    }
                }`,

            variables: {
                actionInput: action
            }
        });
    },

    bulkUpdateState: function(state, filter, sortField=null, sortDirection=null, ids=null){

        return di.get('apollo').mutate({

            mutation: gql`
                mutation ($state: ActionState!, $filter: ActionFilter, $ids: [ID], $sortField: ActionSortField, $sortDirection: SortDirection) {
                    bulkUpdateActionState(state: $state, filter: $filter, ids: $ids, sortDirection: $sortDirection, sortField: $sortField)
                }`,

            variables: {
                state, filter, ids, sortField, sortDirection
            }
        });
    }
}
